/* eslint-disable import/prefer-default-export */
import setupSentry from './src/sentry';
import './src/styles/global.css';

setupSentry();
